import axios from 'axios';

export const DEFAULT_BASE_URL = 'https://dsarsa.com';

export const fetchWidgetSettings = async (accountId, baseUrl = DEFAULT_BASE_URL) => {
  return axios
      .get(`${baseUrl}/api/widget_settings`, {
        params: {
          account_id: accountId
        }
      })
      .then((res) => {
          return res.data.data;
      });
};

export const fetchChatToken = async (unitToken, apiUrl) => {
  if (!apiUrl) {
    throw new Error('API_URL is required');
  }

  if (!unitToken) {
    throw new Error('Unit token is required');
  }

  const { data } = await axios.post(
    `https://${apiUrl}/v1/chat/token/create`,
    {
      token: unitToken,
    }
  );

  return data.chat_token;
};
